<script setup lang="ts">
import { ref } from 'vue'
// a key map of allowed keys
const allowedKeys = ['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'a', 'b']

// the 'official' Konami Code sequence
const konamiCode = [
    'ArrowUp',
    'ArrowUp',
    'ArrowDown',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'ArrowLeft',
    'ArrowRight',
    'b',
    'a'
]

// a variable to remember the 'position' the user has reached so far.
var konamiCodePosition = 0

const konamiCodeActivated = ref(false)
const activateCheats = (value: boolean) => {
    if (value) {
        console.log('activated')
        return (konamiCodeActivated.value = true)
    }
    console.log('deactivated')
    return (konamiCodeActivated.value = false)
}

// add keydown event listener
document.addEventListener('keydown', function (e) {
    if (!allowedKeys.find(item => item === e.key)) return
    if (e.key === konamiCode[konamiCodePosition]) {
        // compare the key with the required key
        // move to the next key in the konami code sequence
        konamiCodePosition++

        // if the last key is reached, activate cheats
        if (konamiCodePosition === konamiCode.length) {
            activateCheats(konamiCodeActivated.value === true ? false : true)
            konamiCodePosition = 0
        }
    } else {
        konamiCodePosition = 0
    }
})
</script>

<template>
    <slot v-bind="{ class: konamiCodeActivated ? 'konami-code' : '' }" />
</template>

<style lang="scss">
.konami-code {
    & .deimpersonate-item .deimpersonate-button {
        box-shadow: 0px 0px 20px 6px #3283a8;
        .mdi-account-cowboy-hat {
            &::before {
                color: #3283a8;
            }
        }
    }
}
</style>
